import { FeatureFlag } from '@/constants/featureFlags';
import { type Customer } from '@/types/checkout';

export const shouldHideEmail = (featureFlags: Record<FeatureFlag, boolean>, customer?: Customer) => {
  return featureFlags[FeatureFlag.CHECKOUT_ENFORCE_CUSTOMER_EMAIL] || Boolean(customer?.email);
};

export const shouldShowLoader = (featureFlags: Record<FeatureFlag, boolean>) => {
  return !featureFlags[FeatureFlag.CHECKOUT_DISABLE_PROCESSING_SCREEN];
};

export const shouldShowSuccessScreen = (featureFlags: Record<FeatureFlag, boolean>) => {
  return !featureFlags[FeatureFlag.CHECKOUT_DISABLE_SUCCESS_SCREEN];
};

export const shouldHideXButton = (featureFlags: Record<FeatureFlag, boolean>) => {
  return featureFlags[FeatureFlag.CHECKOUT_DEEPLINKS_DISABLE_STORE];
};
